<template>
    <div v-show="visible">
        <el-dialog title="积分和金币兑换比率设置" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" style="font-size:20px;">

                    <span style="font-weight:bold">积分&nbsp;&nbsp;:&nbsp;&nbsp;金币&nbsp;&nbsp;</span>=&nbsp;&nbsp;
                    <el-input v-model="form.value" maxlength="5" @input="(e) => (form.value = integerFn(e))" type="number" style="width:100px;"></el-input>&nbsp;&nbsp;:&nbsp;&nbsp;1
                    
                    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    value:"",
                }
            }
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId = deptId;
                this.initData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            initData(){
                let url= this.setcommonParamGetDictUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        console.log(res);
                        this.form.id = res.data.dictId;
                        this.form.value = res.data.value;
                        this.visible=true;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            save(){
                 
                if(this.form.value == ''){
                    this.$commonFn.showTip('请输入积分兑换金币比例值',3);
                    return;
                }

                let url= this.setcommonParamUpdateDictUrl;
                let data = {
                    value:this.form.value,
                    id:this.form.id
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.visible=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                }); 
            },
            /**
             * 只能输入大于0的正整数（不能以0开头）
             * @param {string} value
             * @returns {string | number} 返回空字符或数字
             */
            integerFn(value) {
                let reg = /[1-9]{1}[0-9]*$/;
                let strArray = value.split("");
                let newStrs = "";
                for (let i = 0; i < strArray.length; i++) {
                    if (reg.test(strArray[i])) {
                        newStrs += strArray[i];
                    } else if (i > 0 && strArray[i] === "0") {
                        newStrs += strArray[i];
                    }
                }
                if (newStrs - 0 > 0) {
                    return newStrs - 0;
                } else {
                    return "";
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/studentSet/GoldCoinExchangeset.vue